// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui from "../shared/Ui.re.mjs";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Core from "@linaria/core";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

function IdeaList$Item(props) {
  var __preloadImage = props.preloadImage;
  var item = props.item;
  var preloadImage = __preloadImage !== undefined ? __preloadImage : false;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h3", {
                              children: item.name,
                              className: Core.cx("text-lg font-bold text-gray-900")
                            }),
                        JsxRuntime.jsx("p", {
                              children: item.description,
                              className: Core.cx("mt-2 text-sm text-gray-500")
                            })
                      ],
                      className: Core.cx("mt-6 lg:mt-0 lg:col-span-5 xl:col-span-4")
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(ReactRouterDom.Link, {
                                  to: item.link,
                                  children: JsxRuntime.jsx(Ui.DImg.make, {
                                        src: item.image.src,
                                        alt: item.image.alt,
                                        className: Core.cx("object-center object-cover"),
                                        imgixParams: {
                                          fit: "crop",
                                          crop: "faces",
                                          ar: "800:320"
                                        },
                                        breakpoints: {
                                          default: "calc(100vw - (1rem)*2)",
                                          sm: "calc(640px - 1.5rem*2)",
                                          md: "calc(768px - 1.5rem*2)",
                                          lg: "calc((1024px - 2rem*2)*(7/12))",
                                          xl: "calc((1280px - 2rem*2)*(8/12))",
                                          xxl: "calc((1536px - 2rem*2)*(8/12))"
                                        },
                                        lazyLoad: !preloadImage
                                      }),
                                  reloadDocument: true
                                }),
                            className: Core.cx("aspect-w-5 aspect-h-2 rounded-lg bg-gray-100 overflow-hidden")
                          }),
                      className: Core.cx("flex-auto lg:col-span-7 xl:col-span-8")
                    })
              ],
              className: Core.cx("flex flex-col-reverse lg:grid lg:grid-cols-12 lg:gap-x-8 lg:items-center")
            }, item.name);
}

var Item = {
  make: IdeaList$Item
};

function IdeaList(props) {
  var __preloadFirstItem = props.preloadFirstItem;
  var items = props.items;
  var preloadFirstItem = __preloadFirstItem !== undefined ? __preloadFirstItem : true;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              children: props.title,
                              className: Core.cx("font-semibold text-gray-500")
                            }),
                        JsxRuntime.jsx("p", {
                              children: props.subtitle,
                              className: Core.cx("mt-2 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl")
                            }),
                        JsxRuntime.jsx("p", {
                              children: props.description,
                              className: Core.cx("mt-4 text-gray-500")
                            })
                      ],
                      className: Core.cx("max-w-3xl")
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(items, 0), (function (item) {
                                    return JsxRuntime.jsx(IdeaList$Item, {
                                                item: item,
                                                preloadImage: preloadFirstItem
                                              }, item.id);
                                  })), null),
                        Belt_Array.map(Belt_Array.sliceToEnd(items, 1), (function (item) {
                                return JsxRuntime.jsx(IdeaList$Item, {
                                            item: item
                                          }, item.id);
                              }))
                      ],
                      className: Core.cx("space-y-16 pt-10 mt-10 border-t border-gray-200 sm:pt-16 sm:mt-16")
                    })
              ],
              className: Core.cx("mx-auto px-0 lg:max-w-none")
            });
}

var make = IdeaList;

export {
  Item ,
  make ,
}
/*  Not a pure module */
